<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <rkm-form-date-picker
                    :max-date="data.form.dataAtual"
                    :validations="validations.dataAnotacao"
                    label="Data da anotação"
                    v-model="model.dataAnotacao"
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-time-picker
                    :validations="validations.horaAnotacao"
                    label="Hora da anotação"
                    v-model="model.horaAnotacao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.anotacao"
                    label="Anotação"
                    max-rows="5"
                    v-model="model.anotacao"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Others.
import moment from 'moment'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                dataAnotacao: { required: true },
                horaAnotacao: { required: true },
                anotacao: {
                    required: true,
                    max: 6000,
                },
            }
        },
    },
    created() {

        this.repositories = {
            dataHora: this.getConectaSusRepository('dataHora')
        }
    },
    data: () => ({
        repositories: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {
            this.$refs.RkmForm.validate().then(response => {

                if (!response) return

                const dataHoraAnotacao =
                    moment(this.model.dataAnotacao).format('DD/MM/YYYY') + ' ' +
                    moment(this.model.horaAnotacao, 'HH:mm').format('HH:mm')

                this.setLoading()

                this.repositories.dataHora.get({ formato: 'd/m/Y H:i' })
                    .then(({ data }) => {

                        if (moment(dataHoraAnotacao, 'DD/MM/YYYY HH:mm') > moment(data, 'DD/MM/YYYY HH:mm')) {

                            this.showValidationNotification('A hora deve ser menor ou igual a hora atual.')

                            return
                        }

                        this.model.dataHoraAnotacao = dataHoraAnotacao

                        if (this.model.id) {
                            const index = this.data.model.anotacoes.findIndex(item => item.id === this.model.id)
                            Object.assign(this.data.model.anotacoes[index], this.model)
                        } else {
                            this.model.id = this.uniqueId('pronto-atendimento-anotacao-enfermagem')
                            this.data.model.anotacoes.push(this.model)
                        }

                        this.$emit('saved', this.model)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
    },
    mixins: [repository, error],
    props: {
        data: { type: Object, required: true },
        model: { type: Object, required: true },
    },
}
</script>